/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './TalonOneRewards-ActionTypes';

const initialState = {
    data: null,
    isLoading: false,
    isError: false,
    error: null,
};

const talonOneRewardsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_TALON_ONE_REWARDS:
            return {
                ...state,
                isLoading: true,
                isError: false,
                error: null,
            };
        case actionTypes.FETCH_TALON_ONE_REWARDS_SUCCESS:
            return {
                ...state,
                data: action.data,
                isLoading: false,
                isError: false,
                error: null,
            };
        case actionTypes.FETCH_TALON_ONE_REWARDS_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                error: action.error,
            };
        case actionTypes.CLEAR_TALON_ONE_REWARDS:
            return initialState;
        default:
            return state;
    }
};

export default talonOneRewardsReducer;
